var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"entity-name":_vm.$t('allergicSource'),"model":_vm.model,"icon":"mdi-chart-bubble"},scopedSlots:_vm._u([{key:"item.icon",fn:function({item}){return [_c('v-icon',[_vm._v(_vm._s(item.icon))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }